import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { LockedIcon, VisionrLogo } from 'src/assets/icons';

import { StyledWrapper, StyledSpinner, StyledIcon, StyledText, StyledEmblem } from './AuthenticatingState.styled';

export const AuthenticatingState: React.FunctionComponent = () => {
  const { t } = useTranslation();
  return (
    <StyledWrapper>
      <StyledIcon>
        <LockedIcon />
      </StyledIcon>
      <StyledSpinner>&nbsp;</StyledSpinner>

      <StyledText>
        {t('uiLabel.authenticating')}
        <br /> {t('uiLabel.authenticating.description')}
      </StyledText>
      <StyledEmblem>
        <VisionrLogo />
      </StyledEmblem>
    </StyledWrapper>
  );
};
